import { useState } from 'react';
import { Link as RouterLink, useNavigate, useLocation, matchPath } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  AppBar,
  Box,
  Hidden,
  IconButton,
  Toolbar,
  Button,
} from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import MenuIcon from '@material-ui/icons/Menu';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import LogoDashboard from './LogoDashboard';

import { getCurrentUser, logout } from "../utils/auth"
import getInitials from '../utils/getInitials';

import { itemsMenu } from "./DashboardSidebar"

const DashboardNavbar = ({ onMobileNavOpen, ...rest }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const currentUser = getCurrentUser()

  const theme = useTheme();
  const mediaQueryUpSm = useMediaQuery(theme.breakpoints.up('sm'));
  const mediaQueryUpLg = useMediaQuery(theme.breakpoints.up('lg'));

  return (
    <AppBar
      elevation={0}
      sx={{background:"#FFFFFF", borderBottom:"1px solid black"}}
      {...rest}
    >
      <Toolbar sx={{height: "64px !important", minHeight: "64px !important", background:"#FFFFFF",}}>
        <Box sx={{
          display:"flex",
          alignItems:"center",
          borderRight: mediaQueryUpSm ?" 1px solid black" : "0",
          height:"100%"
        }}>
          <IconButton onClick={onMobileNavOpen} size="small" sx={{height:"34px", visibility: mediaQueryUpLg?"hidden":"visible"}}>
            <MenuIcon />
          </IconButton>
          <RouterLink to="/" style={{marginLeft:"15px", marginRight:"25px", display:"flex", alignItems:"center"}}>
            <LogoDashboard />
          </RouterLink>
          <Hidden lgDown>
            <Box sx={{display:"flex", marginLeft:"25px", marginRight:"25px"}}>
              {itemsMenu.map((item, index) => {
                const active = item?.href ? !!matchPath({
                  path: item?.href,
                  end: false
                }, location.pathname) : false;
                return (
                  <Button
                    key={index}
                    component={RouterLink}
                    sx={{
                      fontSize:"15px",
                      color:"black",
                      marginLeft:"25px",
                      marginRight:"25px",
                      fontWeight:active ? 600 : 400
                    }}
                    size="small"
                    to={item?.href}
                    endIcon={<KeyboardArrowDownIcon/>}
                  >
                    <span>
                      {item?.title}
                    </span>
                  </Button>
                )
              })}
              <Button
                sx={{
                  fontSize:"15px",
                  color:"black",
                  marginLeft:"25px",
                  marginRight:"25px",
                }}
                size="small"
                onClick={() => { logout(() => navigate("/")) } }
                
              >
                <span>
                  Déconnexion
                </span>
              </Button>
            </Box>
          </Hidden>
        </Box>
        <Box sx={{ flexGrow: 1 }}>
        </Box>
        <Box sx={{
          display:"flex",
          alignItems:"center",
          gap:"7px",
          borderLeft: mediaQueryUpSm ?" 1px solid black" : "0",
          height:"100%"
        }}>
          <AccountCircleIcon sx={{width:"30px", height:"30px", color:"text.primary", marginLeft:"10px"}}/>
          <Hidden smDown>
            <Box sx={{color:"text.black", fontSize:"15px"}}>{currentUser?.name}</Box>
          </Hidden>
          <Hidden smUp>
            <Box sx={{color:"text.black", fontSize:"15px"}}>{getInitials(currentUser?.name)}</Box>
          </Hidden>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

DashboardNavbar.propTypes = {
  onMobileNavOpen: PropTypes.func
};

export default DashboardNavbar;
